import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import type { StudentGroupWithAttendance } from './StudentGroupWithAttendance'

type StudentMember = StudentGroupWithAttendance['memberList'][number]
type ConstructorParams = {
  studentByLessonClassArr: StudentGroupWithAttendance[]
  studentByGradeArr: StudentGroupWithAttendance[]
}

// TODO: 이거 쓰는곳 다 지우고 StudentGroups + AttendanceByStudentId로 변경
// Deprecated
export class StudentGroupWithAttendanceColl {
  private gradeMap: CheckableMap<StudentGroupWithAttendance['groupId'], StudentGroupWithAttendance>
  private lessonMap: CheckableMap<StudentGroupWithAttendance['id'], StudentGroupWithAttendance>

  constructor({ studentByGradeArr, studentByLessonClassArr }: ConstructorParams) {
    makeAutoObservable(this)

    this.gradeMap = CheckableMap.fromArr(studentByGradeArr, 'groupId')
    this.lessonMap = CheckableMap.fromArr(studentByLessonClassArr, 'id')
  }

  get isGradeEmpty() {
    return this.gradeMap.isEmpty
  }

  get isLessonEmpty() {
    return this.lessonMap.isEmpty
  }

  getGradeGroup(key: StudentGroupWithAttendance['groupId']) {
    return this.gradeMap.get(key)
  }

  getStudentByGrade() {
    return this.gradeMap
  }

  getStudentByLessonClass() {
    return this.lessonMap
  }

  getLessonClassGroup(key: StudentGroupWithAttendance['id']) {
    return this.lessonMap.get(key)
  }

  // TODO: 리펙토링시 이 클래스 지우고 StudentColl + 추가 정보 결합한 형태로
  updateStudentInfo(studentMember: Partial<StudentMember> & Pick<StudentMember, 'id'>) {
    for (const grade of this.gradeMap.toArr) {
      const beforeMember = grade.memberColl.get(studentMember.id)
      if (!beforeMember) {
        continue
      }
      grade.memberColl.set(studentMember.id, {
        ...beforeMember,
        ...studentMember,
      })
    }
    for (const lessonClass of this.lessonMap.toArr) {
      const beforeMember = lessonClass.memberColl.get(studentMember.id)
      if (!beforeMember) {
        continue
      }
      lessonClass.memberColl.set(studentMember.id, {
        ...beforeMember,
        ...studentMember,
      })
    }
  }
}
